import {
  PRINT_RECEIPT_ASYNC,
  SELECT_AGGREGATOR,
  SET_PRINTER_HOST,
  SET_PRINTER_URL,
} from "../constants/actionTypesTpos";
import { Aggregator } from "../types/config";
import {
  PrintReceiptAsyncAction,
  SetPrinterHostAction,
  SetPrinterUrlAction,
} from "../types/printer";
import { Order } from "../types/order";

const selectAggregator = (payload: Aggregator) => {
  return { type: SELECT_AGGREGATOR, payload };
};

const setPrinterHost = (payload: string): SetPrinterHostAction => {
  return { type: SET_PRINTER_HOST, payload };
};

const setPrinterUrl = (payload: string): SetPrinterUrlAction => {
  return { type: SET_PRINTER_URL, payload };
};

const printReceiptAsync = (payload: Order): PrintReceiptAsyncAction => {
  return { type: PRINT_RECEIPT_ASYNC, payload };
};

export { selectAggregator, setPrinterHost, setPrinterUrl, printReceiptAsync };
